import type { ProduitCatalogueCooperativeB2AgApiResponse } from '@b2ag/module-product-sdk'
import type { CooperativeProduct } from './product'
import { mapFromApi as mapProductFromApi } from './product.mapper'

// eslint-disable-next-line import/prefer-default-export
export const mapFromApi = (productList: ProduitCatalogueCooperativeB2AgApiResponse[] = []): CooperativeProduct[] =>
  productList.map(mapProductFromApi)
